<template>
    <v-container v-if="bot_allow_sla_monitor !=='0'">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('SLASettings')|capitalize }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-switch v-model="enableSLAMonitor" v-on:change="updateSLAConfig">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('SLAConfig.enableSLAMonitor')|capitalize }}: <strong
                                                :class="enableSLAMonitor?'success--text':'error--text'">{{$t(enableSLAMonitor?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                                <p>{{ $t('SLAConfig.timeBetweenAssignedAndResponse') }}</p>
                                <div >
                                 <v-radio-group v-model="config.type" inline row v-if="supportingSkills.length > 1" @change="updateSLAConfig">
                                    <v-radio color="#0052CC" :label="$t('SLAConfig.configForAllSkills')" value="all"></v-radio>
                                    <v-radio color="#0052CC" :label="$t('SLAConfig.configForEachSkill')" value="specific"></v-radio>
                                    </v-radio-group>
                                </div>
                                <div v-if="config.type==='all' || supportingSkills.length <= 1" class="d-flex align-center">
                                    <div class="input">
                                        <v-text-field 
                                            placeholder="Type minutes" 
                                            type="number"
                                            ref="allSkillInput" 
                                            outline 
                                            solo 
                                            dense 
                                            flat 
                                            style="font-size: 14px" 
                                            :min="2"
                                            :max="30" 
                                            v-model="config.all" 
                                            @change="handleChangeDuration(config.all)" 
                                            @keypress="filterDuration" 
                                            :rules="[v => !!v || $t('fieldCannotBeEmpty')]">

                                        </v-text-field>
                                    </div>
                                    <div>
                                    <v-btn flat icon depressed color="#757575" style="margin-top:-18px;" @click="updateSLAConfig">
                                                            <v-icon>mdi-content-save</v-icon>
                                                            </v-btn>
                                  </div>
                                </div>
                                <div v-if="config.type==='specific' && supportingSkills.length > 1" class="d-flex align-center"  v-for="(skill, index) in supportingSkills" :key="index">
                                    
                                    <p style="max-width: 200px;"> {{ skill.name|capitalize }}</p>    
                                    <div class="input">
                                        <v-text-field 
                                            :ref="'skillInput' + skill.id"  
                                            placeholder="Type minutes" 
                                            type="number" 
                                            outline solo dense flat 
                                            style="font-size: 14px" :min="2" :max="30" 
                                            v-model.number="skill.duration" 
                                            @change="handleChangeDuration(skill.duration,skill.id)"  
                                            @keypress="filterDuration" ></v-text-field>
                                        </div>
                                        <div>
                                        <v-btn flat icon depressed color="#757575" style="margin-top:-18px;" @click="updateSLAConfig">
                                                                <v-icon>mdi-content-save</v-icon>
                                                                </v-btn>
                                    </div>

                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import BotService from "@/services/bot.service";

export default {
        name: "SLAConfig",
        props: {
            botCode: String,
        },
        data() {
            return {
                selectedConfigType: 1,
                bot_allow_sla_monitor: "0",
                loadingDialog: true,
                duration: null,
                enableSLAMonitor: false,
                config: {
                    type: "all",
                    all: 5,
                    specific: {}
                },
                originalConfig: {
                    type: "all",
                    all: 5,
                    specific: {}
                },
                previousAllValue: null,
                supportingSkills: []
            }
        },

        mounted() {
            if (this.botCode) {
                this.fetchConfig();
            }
        },
        methods: {
            
            updateSLAConfig() {
                if(this.supportingSkills.length <= 1){
                    this.config.type="all"
                }
                
                BotService.setSLAConfig_EnableSLAMonitor(this.botCode, this.enableSLAMonitor, this.config)
                    .then((response)=> {
                        this.enableSLAMonitor = response.data.enable
                        this.config = response.data.config
                        this.originalConfig = {...response.data.config}
                        
                        for (let i = 0; i < this.supportingSkills.length; i++) {
                            const skill = this.supportingSkills[i];
                            const idString = skill.id.toString(); // Chuyển id sang chuỗi để so sánh với keys trong config.specific
                            if (this.config.specific && (this.config.specific.hasOwnProperty(idString))) {
                                skill.duration = this.config.specific[idString];
                            }else{
                                skill.duration = 5
                            }
                        }
                        this.$AppService.toastSuccess("Update SLA config success.");
                })
                    .catch(()=>{
                    this.$AppService.toastError("Update SLA config failed");
                    this.config = this.originalConfig
                })
            },
            filterDuration: function(evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();
                
                if (!/^[1-9][0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
           
            handleFocus() {
            // Lưu giá trị trước đó khi focus vào trường
            this.previousValue = this.config.all;
            },
            handleChangeDuration(duration, id){
                duration = parseInt(duration)
                duration = (duration < 2) ? 2 : duration
                duration = (duration > 30) ? 30 : duration
                
                if (this.config.type==='all') {
                    this.config.all = duration
                    // this.$refs['allSkillInput'].lazyValue
                }
                else{
                    this.$refs['skillInput'+id][0].lazyValue = duration;
                    for (const skill of this.supportingSkills) {
                        if (skill.id === id){
                            
                            skill.duration =  duration
                        } 
                        this.config.specific[skill.id] = parseInt(skill.duration)
                       
                    }
                }
            },
        
            fetchConfig() {
                BotService.getSLAConfigs(this.botCode).then((response) => {
                    if (response.data.enable && response.data.enable === "1") {
                        this.enableSLAMonitor = true;
                    } else {
                        this.enableSLAMonitor = false;
                    }
                    if(response.data.rs_categories){
                        this.supportingSkills = response.data.rs_categories
                    }
                    if(response.data.bot_allow_sla_monitor){
                        this.bot_allow_sla_monitor = response.data.bot_allow_sla_monitor
                    }
                    this.supportingSkills.unshift({id:"no_skill", name: this.$t("noSkill"), duration: 5})
                    if(response.data.config && Object.keys(response.data.config).length > 0){
                        if(response.data.config){
                            this.config = response.data.config 
                            // this.config = {}
                            this.originalConfig = {...this.config}
                       
                        } 
                        if(!this.config.hasOwnProperty('specific')){
                            this.config['specific'] = {}
                        }
                        if(!this.config.hasOwnProperty('all')){
                            this.config['all'] = 5
                        }
                        for (let i = 0; i < this.supportingSkills.length; i++) {
                            const skill = this.supportingSkills[i];
                            const idString = skill.id.toString(); // Chuyển id sang chuỗi để so sánh với keys trong config.specific
                            if (this.config.specific && (this.config.specific.hasOwnProperty(idString) || skill.id === "no_skill")) {
                                skill.duration = this.config.specific[idString];
                            }else{
                                skill.duration = 5
                            }
                        }
                    }
                    
                    
                    // this.config = this.$store.state.agentConfig.show_last_bot_message === "1" ? "1" : "0";
                });
            }

        },
        watch: {
            botCode() {
                if (this.botCode) {
                    this.fetchConfig();
                }
            },
        }
    }
</script>

<style scoped>
.title {
  font-size: 18px !important;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 20px
}
::v-deep .v-text-field--outline>.v-input__control>.v-input__slot {
  min-height: 34px !important;
}
::v-deep.v-text-field--outline input {
  margin: 0 !important;
}
::v-deep.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
  border: 1px solid #D9D9D9 !important;
  border-radius: 5px;
}
.input {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 25% !important;
}
.input:focus {
  outline: none !important;
}
</style>
